module.exports = "pegasus/assets/themelp1/small/33.png";